<!-- 客户价格等级 -->
<template>
    <div>
        <div class="form-main">
            <el-form :model="formData" :rules="rules" ref="formData" label-width="120px" class="formData">
                <el-form-item label="绩效属性名称" prop="LevelName">
                    <el-input v-model="formData.LevelName"></el-input>
                </el-form-item>
                <el-form-item label="绩效金额" prop="PricePoint" >
                    <el-input-number v-model="formData.PricePoint" :precision="2" :step="0.1"></el-input-number>
                </el-form-item>
                <el-form-item label="级别数序">
                    <el-input-number v-model="formData.LevelNum" disabled></el-input-number>
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <el-button @click="cancel()">关闭</el-button>
                <el-button class="btn-primary" @click="submitLevelForm">提交</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['levelId', 'count'],
    name: '',
    data() {
        return {
            formData: {
                LevelId: '',
                LevelName: '',
                LevelNum: 1,
                PriceType: 0,
                PricePoint: 0,
                CalcType:0
            },
            rules: {
                LevelName: [
                    {
                        required: true,
                        message: '绩效属性名称必填',
                        trigger: 'blur'
                    }
                ],
                PricePoint: [
                    {
                        required: true,
                        message: '绩效金额必填（必须为数字类型）',
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    mounted() {
        if (this.levelId) {
            this.formData.LevelId = this.levelId;
            this.getLevelInfo();
        }
        if (+this.count) {
            this.formData.LevelNum = +this.count + 1;
        }
    },
    methods: {
        getLevelInfo() {
            let url = '/api/EntpInfoManagement/GetPerfSetById';
            this.$util
                .axiosGet({
                    url: url,
                    data: {
                        LevelId: this.formData.LevelId
                    }
                })
                .then(res => {
                    if (res.data) {
                        this.formData.LevelName = res.data.LevelName;
                        this.formData.LevelNum = res.data.LevelNum;
                        this.formData.PricePoint = res.data.EarnPoint;
                    }
                })
                .catch(() => {});
        },
        // 提交表单
        submitLevelForm() {
            let that = this;
            that.$refs.formData.validate(valid => {
                if (valid) {
                    let url = '/api/EntpInfoManagement/SubmitPerfSet';
                    that.$util
                        .axiosPost({
                            url: url,
                            data: that.formData
                        })
                        .then(() => {
                            that.$util.successMsg('成功提交商品绩效属性');
                            that.$emit('closeDialog', true);
                        })
                        .catch(() => {});
                } else {
                    this.$util.errorMsg('校验不通过');
                    return false;
                }
            });
        },
        cancel() {
            this.$emit('closeDialog');
        }
    }
};
</script>
<style lang="less" scoped>
.form-value {
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    color: #606266;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    width: 100%;
}
.form-column {
    width: 33.33%;
}
.dialog-footer {
    text-align: right;
}
</style>
